import { documentBuilderConstants as constants } from '../_constants/document-builder.constants'

export function decrementLinkId(to, from) {
  return { type: constants.DOCUMENT_DECREMENT_LINKID, to, from }
}

export function incrementLinkId(to, from) {
  return { type: constants.DOCUMENT_INCREMENT_LINKID, to, from }
}

export function getSuccess(document) {
  return { type: constants.DOCUMENT_GET_SUCCESS, document }
}

export function reset() {
  return { type: constants.DOCUMENT_RESET }
}

export function resetIds() {
  return { type: constants.DOCUMENT_RESET_IDS }
}

export function rearrangeItems(from, to) {
  return { type: constants.DOCUMENT_REARRANGE_ITEMS, from, to }
}

export function removeQuestion(item) {
  return { type: constants.DOCUMENT_REMOVE_QUESTION, item }
}

export function deleteData() {
  return { type: constants.DOCUMENT_BUILDER_REMOVE_DATA }
}

export function setEditQuestion(item) {
  return { type: constants.DOCUMENT_BUILDER_SET_EDIT_QUESTION, item };
}

export function setFontSize(size) {
  return { type: constants.DOCUMENT_BUILDER_SET_FONT_SIZE, size }
}

export function setBold(bold) {
  return { type: constants.DOCUMENT_BUILDER_SET_BOLD, bold };
}

export function setHeaderText(text) {
  return { type: constants.DOCUMENT_BUILDER_SET_HEADER_TEXT, text }
}

export function setOnlyAnswer(value) {
  return { type: constants.DOCUMENT_ONLY_ANSWER, value }
}

export function addData(data) {
  return { type: constants.DOCUMENT_BUILDER_ADD_DATA, data }
}